export class Utils {
    static newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    static isEmpty(obj: any) {
        if(obj == null) {
            return true;
        }

        for (const prop in obj) {
            if (Object.hasOwn(obj, prop) && obj[prop] != undefined) {
                return false;
            }
        }

        if(obj.length === 0) {
            return true;
        }

        return true;
    }

    static shiftBit = (value: number) => {
        return 1 << value;
    }

}